export default "__VITE_ASSET__BPVtP58v__"